// extracted by mini-css-extract-plugin
export default {"notifications-container":"notificationprovider_notifications-container__2TTvY"};